module.exports = __webpack_public_path__ + "static/media/takeawaycom.966280e1.png";